module.exports = __webpack_public_path__ + "img/warning.31761986.svg";